<template>
    <modal size="md" class="CampaignShowModal" @close="close">
        <div class="-m-t-xl -m-b-md">
            <campaign-show-full :campaign="campaign" :user="user"></campaign-show-full>
        </div>
    </modal>
</template>
<style lang="less" type="text/less">
@import '~dashboard-less/variables';
</style>
<script type="text/babel">
export default {
    props: ['campaign', 'user'],

    methods: {
        close() {
            this.$emit('close')
        },
    },
}
</script>
